import { render, staticRenderFns } from "./ProjectPriorityTreeReadOnlyView.vue?vue&type=template&id=1a9f3628&scoped=true&"
import script from "./ProjectPriorityTreeReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectPriorityTreeReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPriorityTreeReadOnlyView.vue?vue&type=style&index=0&id=1a9f3628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9f3628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VCard,VFlex})
